import React from 'react';
import { Box, Typography } from '@mui/material';
import BaseModal from '../BaseModal';
import { ErrorDetailsModalProps } from './types';
import './ErrorDetailsModal.scss';

const ErrorDetailsModal: React.FC<ErrorDetailsModalProps> = ({
  open,
  onClose,
  title,
  errors,
}) => {
  return (
    <BaseModal
      dataTestId="error-details-modal"
      open={open}
      onClose={onClose}
      title={title}
      hideSubmit
      cancelText="Close"
    >
      <Box className="errorDetailsContent">
        {errors.length === 0 ? (
          <Typography>No errors to display</Typography>
        ) : (
          <ul className="errorList">
            {errors.map((err, index) => (
              <li key={index} className="errorItem">
                <Typography variant="body2">
                  <strong>Row {err.row_index}:</strong> {err.error}
                </Typography>
              </li>
            ))}
          </ul>
        )}
      </Box>
    </BaseModal>
  );
};

export default ErrorDetailsModal;
